import React from "react";
import axios from 'axios'; 
import Header from './header';
import Center from './center';
import Footer from './footer';

import Alert from 'react-s-alert';
require('react-s-alert/dist/s-alert-default.css');
 
require('react-s-alert/dist/s-alert-css-effects/slide.css');
require('react-s-alert/dist/s-alert-css-effects/scale.css');
require('react-s-alert/dist/s-alert-css-effects/bouncyflip.css');
require('react-s-alert/dist/s-alert-css-effects/flip.css');
require('react-s-alert/dist/s-alert-css-effects/genie.css');
require('react-s-alert/dist/s-alert-css-effects/jelly.css');
require('react-s-alert/dist/s-alert-css-effects/stackslide.css');

require('./index.css');

 

var ScreenWidth = window.innerWidth;
var ScreenHeigh = window.innerHeight;

var WContent = document.getElementById('root').style.width;
var HContent = ScreenHeigh-235;
export default class index extends React.Component {

    AlertPopup=(type,text)=>{
        switch (type) {
            case 'Warning': Alert.warning(text, {position: 'bottom-right',effect: 'slide',onShow: function () {},beep: false,timeout: 3500,offset: 0});break;
            case 'Info': Alert.info(text, {position: 'bottom-right',effect: 'slide',onShow: function () {},beep: false,timeout: 3500,offset: 0});break;
            case 'Error': Alert.error(text, {position: 'bottom-right',effect: 'slide',onShow: function () {},beep: false,timeout: 3500,offset: 0});break;
            case 'Success': Alert.success(text, {position: 'bottom-right',effect: 'slide',onShow: function () {},beep: false,timeout: 3500,offset: 0});break;
            default: Alert.closeAll(); break;
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            WinWidth: ScreenWidth,
            WinHeigh: ScreenHeigh,
            WContent: WContent,
            HTop: (HContent*20)/100,
            HCenter: (HContent*60)/100,
            HFooter: (HContent*20)/100,
            headerData : "",
            centerData :"",
            footerData :"",
        }
    }

    ReturnValue_H = (data) =>{this.setState({headerData : data });}
    ReturnValue_C = (data) =>{this.setState({centerData : data });}
    ReturnValue_F = (data) =>{this.setState({footerData : data });}

    saveData = () =>{
        console.log(this.state.headerData);
        console.log(this.state.centerData);
        console.log(this.state.footerData);
        if(this.state.headerData && this.state.centerData && this.state.footerData){
            for(var i = 0 ; i <= this.state.centerData.length-1 ;i++){
                const parameter = new URLSearchParams();
                parameter.append("user",this.state.footerData.F_user);
                parameter.append("arcode",this.state.headerData.H_Customercode);
                parameter.append("docgroup",this.state.headerData.H_Datatype);
                parameter.append("productcode",this.state.centerData[i].col1);
                parameter.append("warehouse",this.state.centerData[i].col4);
                parameter.append("location",this.state.centerData[i].col5);
                parameter.append("unitcode",this.state.centerData[i].col6);
                parameter.append("creditcode",this.state.headerData.H_Creditcode);
                var url = "http://192.168.1.202:8080/Save?api_key=hqqng8R4nDb6jkHY9XxoJwmNKGIVzgTHvZCuxUaw&jwt="+localStorage.getItem('Token');
                axios.post(url,parameter).then(res => {
                    console.log(res);
                });
            }
        }else{
            this.AlertPopup("Error","บันทึกไม่สำเร็จ!");
        }
    }

    render() {
        return  (
            <div>
                <Alert stack={{limit: 3}} />
                {/* <form > */}
                    <nav class="navbar navbar-dark bg-primary">
                        <div class="flex-list">
                        <ul class="nav navbar-nav">
                            {/* <li><i class="fas fa-save"></i>บันทึก</li> */}
                            <li><button type="button" class="btn btn-xs glyphicon glyphicon-floppy-disk" onClick={this.saveData}> บันทึก</button></li>
                            <li><button type="button" class="btn btn-xs glyphicon glyphicon-file"> ใหม่</button></li>
                            <li><button type="button" class="btn btn-xs glyphicon glyphicon-trash"> ลบ</button></li>
                            <span className="pipe"></span>
                            <li><button type="button" class="btn btn-xs glyphicon glyphicon-print"> พิมพ์</button></li>
                            <li><button type="button" class="btn btn-xs glyphicon glyphicon-log-out" onClick={()=>{window.location.href = 'home'}}></button></li>
                        </ul>
                        </div>
                    </nav>
                    <div class="form-group">
                        <Header HTop={this.state.HTop} WContent={this.state.WContent} ReturnValue_H={this.ReturnValue_H} AlertPopup={this.AlertPopup}/>
                        <Center HCenter={this.state.HCenter} WContent={this.state.WContent} ReturnValue_C={this.ReturnValue_C} AlertPopup={this.AlertPopup}/>
                        <Footer HFooter={this.state.HFooter} WContent={this.state.WContent} ReturnValue_F={this.ReturnValue_F} AlertPopup={this.AlertPopup}/>
                    </div>
                {/* </form>  */}
            </div>
        );
    }
}  
 